<template>
  <el-dialog
    title="调用模版"
    :visible.sync="dialogVisible"
    width="600px"
    @open="handleOpen"
  >
    <el-form ref="selectTmpForm" :model="selectTmpForm" :rules="rules">
      <el-form-item label="">
        <el-select v-model="selectTmpForm.id" placeholder="请选择要调用的模版" style="width: 100%">
          <el-option 
            v-for="item in templateList"
            :disabled="!item.remark"
            :label="item.title" 
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <div slot="footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="confirm">调 用</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    templateList: {
      type: Array,
      required: true,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      selectTmpForm: {
        id: ''
      },
      rules: {
        id: {required: true, message:'请选择要调用的模版', trigger: ['change', 'blur' ]}
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(newVal) {
        this.$emit('update:visible', newVal)
      }
    },
    templateListMap() {
      return this.templateList.map(item => {
        return {
          ...item,
          title: item.remark ? `(${item.message})+${item.title}` : item.title
        }
      })
    }
  },
  methods: {
    handleOpen() {
      this.selectTmpForm.id = ''
    },
    confirm() {
      this.$refs.selectTmpForm.validate(valid => {
        if (!valid) return
        this.$emit('confirm', this.selectTmpForm.id);
        this.close();
      })   
    },
    close() {
      this.dialogVisible = false
    }
  },
}
</script>

<style lang="scss" scoped>

</style>